import Audio from 'pages/PhoneManagement/Audio';
import Devices from 'pages/PhoneManagement/Devices';
import Extensions from 'pages/PhoneManagement/Extensions';
import General from 'pages/PhoneManagement/General';
import CallRecording from 'pages/PhoneManagement/General/CallRecording';
import CallerID from 'pages/PhoneManagement/General/CallerID';
import E911Location from 'pages/PhoneManagement/General/E911Location';
import Preferences from 'pages/PhoneManagement/General/Preferences';
import TCR from 'pages/PhoneManagement/TCR';
import Numbers from 'pages/PhoneManagement/Numbers';
import DylNumbers from 'pages/PhoneManagement/Numbers/DylNumbers';
import ExternalNumbers from 'pages/PhoneManagement/Numbers/ExternalNumbers';
import Routing from 'pages/PhoneManagement/Routing';
import { Route } from 'react-router-dom';
import Users from 'pages/PhoneManagement/Extensions/Users';
import Company from 'pages/PhoneManagement/Extensions/Company';
import RingGroupCallQueues from 'pages/PhoneManagement/Routing/RingGroupCallQueues';
import DestinationGroups from 'pages/PhoneManagement/Routing/DestinationGroups';
import IVRPrompts from 'pages/PhoneManagement/Routing/IVRPrompts';
import CallRoutingRules from 'pages/PhoneManagement/Routing/CallRoutingRules';
import BrandRegistration from 'pages/PhoneManagement/TCR/BrandRegistration';
import CampaignRegistration from 'pages/PhoneManagement/TCR/CampaignRegistration';
import TextingPreferences from 'pages/PhoneManagement/TCR/TextingPreferences';
import RestrictedView from 'shared/RestrictedView';
import { USER_PERMISSIONS, PRODUCT_PERMISSIONS } from 'dyl-components';
import HolidaySchedule from 'pages/PhoneManagement/General/HolidaySchedule';

const ROUTES = {
    callRecording: 'call-recording',
    callerId: 'caller-id',
    e911Locaation: 'e911-location',
    holidaySchedule: 'holiday-schedule',
    tcr: 'tcr',
    preferences: 'preferences',
    dylNumbers: 'dyl-numbers',
    externalNumbers: 'external-numbers',
    users: 'users',
    company: 'company',
    devices: 'devices',
    ringGroupCallQueues: 'ring-group-call-queues',
    destinationGroups: 'destination-groups',
    ivrPrompts: 'ivr-prompts',
    callRoutingRules: 'call-routing-rules',
    audio: 'audio', 
    brand: 'brand-registration',
    campaign: 'campaign-registration',
    textingPreferences: 'texting-preferences',
}

export const PHONE_MANAGEMENT_ROUTES = [
    <Route path='general' element={<General />}>
        <Route path={ROUTES.callRecording} element={
            <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}general/${ROUTES.callRecording}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                <CallRecording /> 
            </RestrictedView>
            } 
        />
        <Route path={ROUTES.callerId} element={
            <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}general/${ROUTES.callerId}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                <CallerID /> 
            </RestrictedView>
            } 
        />
        <Route path={ROUTES.e911Locaation} element={
            <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}general/${ROUTES.e911Locaation}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                <E911Location />
            </RestrictedView>
            } 
        />
        <Route path={ROUTES.holidaySchedule} element={
            <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}general/${ROUTES.holidaySchedule}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                <HolidaySchedule /> 
            </RestrictedView>
            } 
        />
        <Route path={ROUTES.preferences} element={
            <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}general/${ROUTES.preferences}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                <Preferences />
            </RestrictedView>
            } 
        />
    </Route>,
    <Route path='numbers' element={<Numbers />}>
        <Route path={ROUTES.dylNumbers} element={
            <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}numbers/${ROUTES.dylNumbers}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                <DylNumbers />
            </RestrictedView>
            } 
        />
        <Route path={ROUTES.externalNumbers} element={
            <RestrictedView type="restricted" userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                <ExternalNumbers />
            </RestrictedView>
            } 
        />
    </Route>,
    <Route path='extensions' element={<Extensions />} >
        <Route path={ROUTES.users} element={
            <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}extensions/${ROUTES.users}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                <Users />
            </RestrictedView>
            } 
        />
        <Route path={ROUTES.company} element={
            <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}extensions/${ROUTES.company}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                <Company />
            </RestrictedView>
            } 
        />
    </Route>,
    <Route path={ROUTES.devices} element={
        <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}${ROUTES.devices}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
            <Devices />
        </RestrictedView>
        } 
    />,
    <Route path='routing' element={<Routing />}>
        <Route path={ROUTES.ringGroupCallQueues} element={
            <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}routing/${ROUTES.ringGroupCallQueues}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                <RingGroupCallQueues />
            </RestrictedView>
            } 
        />
        <Route path={ROUTES.destinationGroups} element={
            <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}routing/${ROUTES.destinationGroups}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                <DestinationGroups />
            </RestrictedView>
            } 
        />
        <Route path={ROUTES.ivrPrompts} element={
            <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}routing/${ROUTES.ivrPrompts}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                <IVRPrompts />
            </RestrictedView>
            } 
        />
        <Route path={ROUTES.callRoutingRules} element={
            <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}routing/${ROUTES.callRoutingRules}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                <CallRoutingRules />
            </RestrictedView>
            } 
        />
    </Route>,
    <Route path={ROUTES.audio} element={
        <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}${ROUTES.audio}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
            <Audio />
        </RestrictedView>
        } 
    />,
    <Route path='tcr' element={
        <TCR />
     }>
    <Route path={ROUTES.brand} element={
        <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}${ROUTES.tcr}/${ROUTES.brand}`} userPermission={USER_PERMISSIONS.BRAND_REGISTRATION_VIEW}>
            <BrandRegistration />
        </RestrictedView>
    } />
    <Route path={ROUTES.campaign} element={
        <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}${ROUTES.tcr}/${ROUTES.campaign}`} userPermission={USER_PERMISSIONS.CAMPAIGN_REGISTRATION_VIEW}>
            <CampaignRegistration />
        </RestrictedView>
    } />
    <Route path={ROUTES.textingPreferences} element={
        <RestrictedView type="restricted" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}${ROUTES.tcr}/${ROUTES.textingPreferences}`} userPermission={USER_PERMISSIONS.TEXTING_PREFERENCES_VIEW}>
            <TextingPreferences />
        </RestrictedView>
    } />
    </Route>
];
